<!--首购订单(代办处)-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <div v-show="registerIF === 0">
        <el-form label-width="auto">
          <el-row :gutter="20">
            <el-col :md="8" :lg="8" :xl="8">
              <el-form-item size="mini"  :label="$t('miMember.memberNo')">
                <el-input v-model.trim="memberNo" clearable @blur="getAgentno()" />
                <span v-if="this.isShouGou === true" style="color:red;">{{this.$t('miMember.FOrder.has')}}</span>
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="8" :xl="6">
              <p :class="{ 'account_name_css': account_name_show}" style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ memberNo_span }}</p>
            </el-col>
          </el-row>
        </el-form>
        <p style="margin-left: 43px">{{ this.$t('sys.ask.unregistered') }}<span style="color: #1791e6; cursor: pointer;" @click="registerIF = 2">{{ this.$t('tips.click.here') }}</span></p>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button size="mini" v-loading="saveLoading" :disabled="oneNextIf" type="success" icon="el-icon-right" @click="btnNextStep">{{ $t('button.next') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <div v-show="registerIF === 1">
        <el-form>
          <!-- 基本信息 -->
          <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
          <!-- 经销商编号 -->
          <el-form-item :label="$t('miMember.memberNo')+ ':'">
            {{ commodityInfoTwo.memberNo }}
          </el-form-item>
          <!-- 推荐人编号 -->
          <el-form-item :label="$t('mi.recommendNo')+ ':'">
            {{ commodityInfoTwo.recommendNo }}
          </el-form-item>
          <!-- 安置人编号 -->
          <el-form-item :label="$t('mi.linkNo')+ ':'">
            {{ commodityInfoTwo.linkNo }}
          </el-form-item>
        </el-form>
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">
          {{$t('pmEfuboCard.amount')}}<span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalfA}}</span>
          FV <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalFv}}</span>
        </p>
        <el-table
            :data="list"
            border
            size="mini"
            fit
            highlight-current-row
            style="width: 100%;"
        >
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
<!--          商品编码（旧）-->
          <el-table-column :label="$t('BiGoods.goodsCode.old')" prop="oldcode" align="center" />
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />
          <!--      积分 busi.direct.sale_points-->
          <el-table-column :label="$t('FV')" prop="standardPv" align="center" />
          <!--      是否赠品    -->
<!--          <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">-->
<!--            <template v-slot="{row}">-->
<!--              {{$lt(initDict.physicalpoint,row.productForm)}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" >
            <template v-slot="{row}">
              {{$t(StockNumberString(row.validQty))}}
            </template>
          </el-table-column>
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" width="200" align="center">
            <template slot-scope="{row}">
              <el-input-number
                  v-model="row.buyQty"
                  size="mini"
                  :min="0"
                  style="width:100px;"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-form label-width="150px">
          <!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px;margin-top: 10px"  :label="$t('please.input.your.pay.password')" :rules="{ required: true, message: this.$t('label.pleaseFillIn'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="payPassword" show-password clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--      上一步-->
          <el-button size="mini" v-loading="saveLoading" type="primary" icon="el-icon-back" @click="registerIF = 0">{{ $t('button.previous') }}</el-button>
          <!--        提交-->
          <el-button size="mini" v-loading="saveLoading" type="success" icon="el-icon-check" @click="titlesubmit()">{{ $t('title.submit') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <!--注册-->
      <div v-show="registerIF === 2">
        <p>{{ this.$t('sys.ask.registered') }}<span style="color: #1791e6; cursor: pointer;" @click="registerIF = 0">{{ this.$t('tips.click.here') }}</span></p>
        <el-form ref="registerRef" :model="registerInfo" :rules="rules" label-width="130px" size="mini">
          <!-- 基本信息 -->
          <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
          <!-- 会员编号 -->
          <el-form-item :label="$t('poOrder.memberNo')+':'" required class="turn-white">
            <el-input disabled v-model="registerInfo.memberNo" style="width: 80%" :placeholder="$t('')" />
           </el-form-item>
          <!-- 推荐人编号 -->
          <el-form-item :label="$t('mi.recommendNo')+ ':'" prop="recommendNo">
            <el-input v-model.trim="registerInfo.recommendNo" clearable style="width: 80%" @blur="recommendNoBlur($event.target.value)"/>
            <span :class="{ 'account_name_css':  recommendName_span_show}" class="red-span">{{ recommendName_span }}</span>
          </el-form-item>
          <!-- 安置人编号 -->
          <el-form-item :label="$t('mi.linkNo')+ ':'" prop="linkNo">
            <el-input v-model.trim="registerInfo.linkNo" clearable style="width: 80%" @blur="tmpLinkNoBlur($event.target.value)"/>
            <span :class="{ 'account_name_css':  tmpLinkNo_span_show}" class="red-span">{{ tmpLinkNo_span }}</span>
            <br>
            <span v-if="tmpLinkNo_num_span >= 4" class="red-span">{{this.$t('agent.tips.market')}} {{ tmpLinkNo_num_span }} {{this.$t('app.limit.market.cn')}}</span>
          </el-form-item>
          <!--电子邮件-->
          <el-form-item :label="$t('sysUser.email')" prop="email">
            <el-input
                v-model.trim="registerInfo.email"
                size="mini"
                style="width: 80%"
                placeholder=" "
            />
          </el-form-item>
          <!-- 经销商姓名 -->
          <el-form-item :label="$t('miMember.name')+ ':'" prop="name">
            <el-input v-model="registerInfo.name" readonly onfocus="this.removeAttribute('readonly')" clearable style="width: 80%" @blur="registerInfo.accountName = registerInfo.name"/>
          </el-form-item>
          <!-- 证件类型 -->
          <el-form-item :label="$t('miAgent.paperType') + ':'" prop="paperType">
            <el-select v-model="registerInfo.paperType" style="width: 80%">
              <el-option v-for="item in BonusTypeList" :label="$lt(initDict.BonusType, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- 证件号 -->
          <el-form-item :label="$t('miAgent.paperNo')+ ':'" prop="paperNo">
            <el-input v-model.trim="registerInfo.paperNo" clearable style="width: 80%" @blur="paperNoBlur($event.target.value)"/>
            <span style="color: red">{{ this.paperNoError }}</span>
          </el-form-item>
          <!-- 联系资料 -->
          <h3 style="color: #b3640d">{{ $t('mi.lable.contact.info') }}</h3>
          <!-- 所在地区 -->
          <el-form-item :label="$t('miAgent.regionCode')+ ':'">
            <AddrSelect :addr-info="AddrInfo" @provinceEmit="getProvinceId" />
          </el-form-item>
          <!-- 详细地址 -->
          <el-form-item :label="$t('miAgent.storeAddr')+ ':'" prop="storeAddr">
            <el-input v-model="registerInfo.storeAddr" clearable style="width: 80%" />
          </el-form-item>
          <!-- 邮政编码 -->
          <el-form-item :label="$t('miAgent.storePost')+ ':'" >
            <el-input v-model.trim="registerInfo.storePost" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 传真 -->
          <el-form-item :label="$t('biVendor.fax')+ ':'">
            <el-input v-model.trim="registerInfo.fax" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 移动电话 -->
          <el-form-item :label="$t('miAgent.mobile')+ ':'" prop="mobile">
            <el-input v-model.trim="registerInfo.mobile" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 银行账户信息 -->
          <h3 style="color: #b3640d">{{ $t('miAgent.title.accountInfo') }}</h3>
          <!-- 开户银行 -->
          <el-form-item v-if="this.companyCode !== 'CO'" :label="$t('miAgent.accountBank') + ':'" prop="accountBank">
            <el-select v-if="this.companyCode === 'GH'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in AccountBankGH" :label="$lt(initDict.accountBank_GH, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
            <el-select v-else-if="this.companyCode === 'ZA'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in AccountBankZA" :label="$lt(initDict.accountBank_ZA, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
            <el-select v-else-if="this.companyCode === 'CI'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in AccountBankCI" :label="$lt(initDict.accountBank_CI, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
            <el-select v-else-if="this.companyCode === 'CM'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in AccountBankCM" :label="$lt(initDict.accountBank_CM, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
            <el-select v-else-if="this.companyCode === 'NG'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in AccountBankNG" :label="$lt(initDict.accountBank_NG, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- 开户银行 -->
          <el-form-item v-if="this.companyCode === 'CO' " :label="$t('miAgent.accountBank')+ ':'" prop="accountBank">
            <el-input v-model.trim="registerInfo.accountBank"  style="width: 80%"/>
          </el-form-item>
          <!-- 户名 -->
          <el-form-item :label="$t('miAgent.accountName')+ ':'" prop="accountName">
            <el-input v-model.trim="registerInfo.accountName" @blur="registerInfo.name = registerInfo.accountName" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 账号 -->
          <el-form-item  :label="$t('miAgent.accountCode')+ ':'" prop="accountCode">
            <el-input v-model.trim="registerInfo.accountCode" readonly onfocus="this.removeAttribute('readonly')" clearable style="width: 80%"/>
          </el-form-item>
<!--          银行转账  -->
          <el-form-item v-if="companyCode=== 'ZA' " prop="branchCode" :label="$t('bank.transfer')+ ':'" >
            <el-input  maxlength="6" v-model="registerInfo.branchCode" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 密码设置 -->
          <h3 style="color: #b3640d">{{ $t('miAgent.title.LoginInfo') }}</h3>
          <!-- 登录密码 -->
          <el-form-item :label="$t('sysUser.userPassword')+ ':'" prop="password">
            <el-input v-model.trim="registerInfo.password" clearable style="width: 200px" show-password readonly onfocus="this.removeAttribute('readonly')"/>
            <span style="color: red;margin-left: 5px">  Require 8 to 16 digits with letters or munber or both</span>
          </el-form-item>
          <!-- 重复密码 -->
          <el-form-item :label="$t('sysUser.repeatPassword')+ ':'" prop="tmpRePassword">
            <el-input v-model.trim="registerInfo.tmpRePassword" clearable style="width: 200px" show-password/>
          </el-form-item>
          <!-- 支付密码 -->
          <el-form-item :label="$t('Common.pay.password')+ ':'" prop="advPassword">
            <el-input v-model.trim="registerInfo.advPassword" clearable style="width: 200px" show-password/>
            <span style="color: red;margin-left: 5px">  The default transaction password is the same as this login password.Please login and change</span>
          </el-form-item>
          <!-- 重复密码 -->
          <el-form-item :label="$t('sysUser.repeatPassword')+ ':'" prop="advRePassword">
            <el-input st v-model.trim="registerInfo.advRePassword" clearable style="width: 200px" show-password/>

          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button :disabled="disabled" size="mini" v-loading="saveLoading" type="success" icon="el-icon-right" @click="btnRegisterInfoSave">{{ $t('button.next') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <!--  注册后选择商品信息-->
      <div v-show="registerIF === 3">
        <el-form class="register_3_css">
          <div style="flex: 1">
            <!-- 基本信息 -->
            <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
            <!-- 会员编号 -->
            <el-form-item :label="$t('poOrder.memberNo')+ ':'">
              {{ commodityInfo.memberNo }}
            </el-form-item>
            <!-- 推荐人编号 -->
            <el-form-item :label="$t('mi.recommendNo')+ ':'">
              {{ commodityInfo.recommendNo }}
            </el-form-item>
            <!-- 安置人编号 -->
            <el-form-item :label="$t('mi.linkNo')+ ':'">
              {{ commodityInfo.linkNo }}
            </el-form-item>
            <!-- 电子邮件 -->
            <el-form-item :label="$t('sysUser.email')+ ':'">
              {{ registerInfo.email }}
            </el-form-item>
            <!-- 经销商姓名 -->
            <el-form-item :label="$t('miMember.name')+ ':'">
              {{ commodityInfo.name }}
            </el-form-item>
            <!-- 证件类型 -->
            <el-form-item :label="$t('miAgent.paperType')+ ':'">
              {{ $lt(initDict.BonusType, commodityInfo.paperType) }}
            </el-form-item>
            <!-- 证件号 -->
            <el-form-item :label="$t('miAgent.paperNo')+ ':'">
              {{ commodityInfo.paperNo }}
            </el-form-item>
            <!-- 奖金发放方式 -->
            <el-form-item :label="$t('bd.bonusSendType')+ ':'">
              {{ $lt(initDict.sendType, commodityInfo.bonusSendType) }}
            </el-form-item>
            <!-- 移动电话 -->
            <el-form-item :label="$t('miAgent.mobile')+ ':'">
              {{ commodityInfo.mobile }}
            </el-form-item>
          </div>
          <div style="flex: 1">
            <!-- 银行账户信息 -->
            <h3 style="color: #b3640d">{{ $t('miAgent.title.accountInfo') }}</h3>
            <!-- 开户银行 -->
            <el-form-item :label="$t('miAgent.accountBank')+ ':'">
              {{ commodityInfo.accountBank }}
            </el-form-item>
            <!-- 户名 -->
            <el-form-item :label="$t('miAgent.accountName')+ ':'">
              {{ commodityInfo.accountName }}
            </el-form-item>
            <!-- 账号 -->
            <el-form-item :label="$t('miAgent.accountCode')+ ':'">
              {{ commodityInfo.accountCode }}
            </el-form-item>
            <!-- 联系资料 -->
            <h3 style="color: #b3640d">{{ $t('mi.lable.contact.info') }}</h3>
            <!-- 移动电话 -->
            <el-form-item :label="$t('miAgent.mobile')+ ':'">
              {{ commodityInfo.mobile }}
            </el-form-item>
            <!-- 所在地区 -->
            <el-form-item :label="$t('miAgent.regionCode')+ ':'">
              {{selectAddr.country}} {{selectAddr.province}}
            </el-form-item>
            <!-- 详细地址 -->
            <el-form-item :label="$t('miAgent.storeAddr')+ ':'">
              {{ commodityInfo.storeAddr }}
            </el-form-item>
          </div>
        </el-form>
        <!-- 商品列表 -->
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">
          {{ $t('pmEfuboCard.amount') }} <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalfA}}</span>
          FV <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalFv}}</span>
        </p>
        <el-table
            :data="list"
            border
            size="mini"
            fit
            highlight-current-row
            style="width: 100%;"
            height="500"
        >
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />
          <!--      积分 busi.direct.sale_points-->
          <el-table-column :label="$t('FV')" prop="standardPv" align="center" />
          <!--      是否赠品    -->
<!--          <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">-->
<!--            <template v-slot="{row}">-->
<!--              {{$lt(initDict.physicalpoint,row.productForm)}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" >
            <template v-slot="{row}">
              {{$t(StockNumberString(row.validQty))}}
            </template>
          </el-table-column>
          <!--      购买数量-->
<!--          <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" align="center" >-->
<!--            <template v-slot="{row}">-->
<!--              <el-input v-model.number="row.buyQty"  />-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--         购买数量 -->
          <el-table-column :label="$t('Common.buyNumber')"  prop="buyQty" width="200" align="center">
            <template slot-scope="{row}">
              <el-input-number
                  @change="handleQuantityChange(row)"
                  v-model="row.buyQty"
                  size="mini"
                  :min="0"
                  style="width:100px;"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-form>
          <el-form-item v-if="CITime && companyCode === 'CI' &&  Number(totalFv) >= 400" :label="$t('pdManifestItem.present') + ':'" required>
            <br>
            <el-radio-group ref="radio" v-model="selectPromotion">
              <el-radio style="margin: 10px 0;" :label="1">Fohow Waist Protect T006-04</el-radio>
              <br>
              <el-radio :label="2">Fohow Kneepad T004-00</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="CITime && companyCode === 'CI' && this.qixueBuyQty > 0" :label="'Blood Circulative Massager' + $t('pdManifestItem.present') + ':'" required>
            <br>
            <div>
              Fohow Waist Protect T006-04
              <el-input-number :min="0" :max="qixueBuyQty - qixue2" size="mini" v-model.number="qixue1" style="width: 100px" />
            </div>
            <div>
              Fohow Kneepad T004-00
              <el-input-number :min="0" :max="qixueBuyQty - qixue1" size="mini" v-model.number="qixue2" style="width: 100px" />
            </div>
          </el-form-item>
          <!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px;margin-top: 10px"  :label="$t('please.input.your.pay.password')" :rules="{ required: true, message: this.$t('label.pleaseFillIn'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="saveInfo.payPassword" show-password clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--        上一步-->
          <el-button size="mini" v-loading="saveLoading" type="primary" icon="el-icon-back" @click="registerIF = 2">{{ $t('button.previous') }}</el-button>
          <!--        提交-->
          <el-button size="mini" v-loading="saveLoading" type="success" icon="el-icon-check" @click="btnSubmit()">{{ $t('title.submit') }}</el-button>
          <!--        取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commonCxTime,
  getCompanyBonusType,
  miMemberInfo,
  miMemberRightNum,
  registerGetMemberNo
} from "@/api/member"
import {
  agentRegisterFirst,
  agentRegisterSecond,
  goodsListSGByMember,
  saveSGA
} from "@/api/ay-business-manager/firstpurchaseorder"
import {mapGetters} from "vuex"
import AddrSelect from "@/components/AddrSelect.vue";
import {StockNumberString} from "@/utils/stock-number-string";
export default {
  name: "FirstpurchaseOrderAgent",
  components: { AddrSelect },
  data() {
    return {
      qixue1: 0,
      qixue2: 0,
      qixueBuyQty: 0,
      CITime: false,
      selectPromotion: 0,
      selectAddr: {
        country: "",
        province: ""
      },
      AddrInfo: [],
      paperNoError: '',
      disabled: false,
      isShouGou: false,
      resSaveInfo: false,
      btnLoading: false,
      saveLoading: false,
      commodityInfoTwo: {
        memberNo: '',
        recommendNo: '',
        linkNo: '',
      },
      payPassword: '',
      saveInfo: {
        payPassword: '',
      },
      commodityInfo: {
        recommendNo: '',
        linkNo: '',
        name: '',
        paperType: '',
        paperNo: '',
        bonusSendType: '',
        mobile: '',
        accountBank: '',
        accountName: '',
        accountCode: '',
        officeTel: '',
        storeAddr: '',
        storePost: '',
      },
      BonusType: '',
      list: [],
      recommendName_span_show: false,
      tmpLinkNo_span_show: false,
      recommendName_span: '',
      tmpLinkNo_span: '',
      tmpLinkNo_num_span: '',
      memberNo_span: '',
      registerIF: 0,
      registerInfo: {
        memberNo: '',
        regionCode: '',
        email: '',
        recommendNo: '',
        linkNo: '',
        name: '',
        paperType: '',
        paperNo: '',
        storeAddr: '',
        storePost: '',
        fax: '',
        mobile: '',
        accountBank: '',
        accountName: '',
        accountCode: '',
        password: '',
        tmpRePassword: ''
      },
      account_name_show: false,
      oneNextIf: true,
      memberNo: '',
      accountName: '',
      rules:{
        recommendNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        linkNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        name: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        paperType: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'change'}],
        paperNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        storeAddr: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        mobile: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        accountCode: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        accountName: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        accountBank: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        branchCode: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        password: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        tmpRePassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        advPassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
        advRePassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: 'blur'}],
      },
      initDict: {
        BonusType: 'miagent.papertype',
        sendType: 'bd.bonus_send_type',
        accountBank_GH: 'gh.bank.list',
        accountBank_ZA: 'za.bank.list',
        accountBank_CI: 'ci.bank.list',
        accountBank_CM: 'cm.bank.list',
        accountBank_NG: 'ng.bank.list',
        physicalpoint:'Is.it.a.physical.point'
      }
    }
  },
  computed: {
    ...mapGetters([
      'companyCode',
      'userCode'
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPrice * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPv * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    buyQty() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.buyQty + acc
      }, 0)
    },
    BonusTypeList() {
      return this.$ll(this.initDict.BonusType)
    },
    AccountBankGH() {
      return this.$ll(this.initDict.accountBank_GH)
    },
    AccountBankZA() {
      return this.$ll(this.initDict.accountBank_ZA)
    },
    AccountBankCI() {
      return this.$ll(this.initDict.accountBank_CI)
    },
    AccountBankCM() {
      return this.$ll(this.initDict.accountBank_CM)
    },
    AccountBankNG() {
      return this.$ll(this.initDict.accountBank_NG)
    }

  },
  created() {
    this.getBonusType()
    this.getGoodsList()
    this.getMemberTimeSix()
    this.getCITime()
  },
  methods: {
    getCITime() {
      commonCxTime().then(res => {
        this.CITime = res.data
      })
    },
    handleQuantityChange(row){
      if (row.buyQty === '' || row.buyQty === 'null' || row.buyQty === undefined) {
        row.buyQty = 0
      }
      if (this.CITime && row.goodscode === 'M010-00' && row.buyQty >= 1) {
        this.qixueBuyQty = row.buyQty
      } else if (this.CITime && row.goodscode === 'M010-00' && row.buyQty <= 0) {
        this.qixueBuyQty = 0
      }
    },
    getMemberTimeSix() {
      registerGetMemberNo({ 'agentNo': this.userCode }).then(res => {
        this.registerInfo.memberNo = res.data
      })
    },
    StockNumberString,
    getProvinceId(val) {
      this.selectAddr = val
      this.registerInfo.regionCode = val ? val.id : ''
    },
    getAgentno(){
      if (this.memberNo) {
        miMemberInfo({'memberNo': this.memberNo}).then(res => {
          this.memberNo_span = res.data.accountName
          this.oneNextIf = false
          this.account_name_show = false
          if(res.data.isShouGou === 0){
            this.oneNextIf = true
            this.isShouGou = true
          }else{
            this.oneNextIf = false
            this.isShouGou = false
          }
        }).catch(() => {
          this.account_name_show = true
          this.isShouGou = false
          this.memberNo_span = ''
          this.oneNextIf = true
        })
      } else {
        this.isShouGou = false
        this.memberNo_span = ''
        this.oneNextIf = true
        this.account_name_show = false
      }
    },
    btnNextStep() {
      this.saveLoading = true
      miMemberInfo({'memberNo': this.memberNo}).then(res => {
        this.commodityInfoTwo.memberNo = res.data.memberNo
        this.commodityInfoTwo.recommendNo = res.data.recommendNo
        this.commodityInfoTwo.linkNo = res.data.linkNo
        this.registerIF = 1
        this.saveLoading = false
      }).catch(() => {
        this.registerIF = 0
        this.saveLoading = false
      })
    },
    titlesubmit() {
      if (this.buyQty <= 0) {
        return this.$message(this.$t('leastInputANumber'))
      }
      if (!this.payPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password'))
      } else {
        let lists = []
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].buyQty > 0) {
            lists.push(this.list[i])
          }
        }
        this.commodityInfoTwo.goodsList = lists
      }
      this.commodityInfoTwo.payPassword = this.payPassword
      this.saveLoading = true
      saveSGA({ ... this.commodityInfoTwo}).then(() => {
        this.saveLoading = false
        this.$router.push({name:'OrderQuery'})
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
      }).catch(() => {
        this.saveLoading = false
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    },
    recommendNoBlur(val) {
      if (val) {
        miMemberInfo({ 'memberNo': val}).then(res => {
          this.recommendName_span =  res.data.name
          this.recommendName_span_show = false
        }).catch(() => {
          this.recommendName_span =  ''
          this.recommendName_span_show = true
        })
      } else {
        this.recommendName_span =  ''
        this.recommendName_span_show = false
      }
    },
    tmpLinkNoBlur(val) {
      if (val) {
        miMemberRightNum({ 'memberNo': val}).then(res =>  {
          this.tmpLinkNo_span = res.data.name
          this.tmpLinkNo_num_span = res.data.num
        }).catch(() =>{
          this.tmpLinkNo_span = ''
          this.tmpLinkNo_num_span = ''
          this.tmpLinkNo_span_show = true
        })
      } else {
        this.tmpLinkNo_span = ''
        this.tmpLinkNo_num_span = ''
        this.tmpLinkNo_span_show = false
      }
    },
    paperNoBlur(val) {
      if (!val) {
        this.paperNoError = ''
        return false
      }
      // if (this.BonusType === '13') {
      //   switch (this.registerInfo.paperType) {
      //     case '1':
      //         if (val.length !== 16) {
      //           this.paperNoError = this.$t('sys.error.paperno')
      //         }
      //         break;
      //     case '2':
      //       if (val.length !== 8) {
      //         this.paperNoError = this.$t('sys.error.paperno')
      //       }
      //       break;
      //     case '3':
      //       if (val.length !== 13) {
      //         this.paperNoError = this.$t('sys.error.paperno')
      //       }
      //       break;
      //   }
      // }
    },
    btnRegisterInfoSave() {
      if(this.companyCode === 'GH'){
        if(this.registerInfo.paperType === '1' && this.registerInfo.paperNo.length !== 10){
          return this.$message.error(this.$t('ID.number.must.be.10.digits'))
        }else if(this.registerInfo.paperType === '2' && this.registerInfo.paperNo.length !== 9){
          return this.$message.error(this.$t('Passport.must.be.9.digits'))
        }
      }
      if (!this.registerInfo.advPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password').toString())
      }
      if (!this.registerInfo.advRePassword) {
        return this.$message.error(this.$t('sysUser.repeatPassword').toString()+
            this.$t('please.input.your.pay.password').toString())
      }
      if (this.registerInfo.password !== this.registerInfo.tmpRePassword) {
        return this.$message.error(this.$t('sysUser.userPassword').toString()+
            this.$t('mi.twice.pwd.disagree.reinput').toString())
      }
      if (this.registerInfo.advPassword !== this.registerInfo.advRePassword) {
        return this.$message.error(this.$t('Common.pay.password').toString()+
            this.$t('mi.twice.pwd.disagree.reinput').toString())
      }
      if( this.companyCode === 'ZA' && this.registerInfo.branchCode.toString().length !== 6){
        return  this.$message.error(this.$t('6-digit.number'))
      }
      if(this.registerInfo.password.toString().length < 8 || this.registerInfo.password.toString().length > 16){
        return  this.$message.error('Require 8 to 16 digits with letters or munber or both')
      }
      this.saveLoading = true
      this.$refs['registerRef'].validate((valid) => {
        if (valid) {
          agentRegisterFirst(this.registerInfo).then(res => {
            this.registerIF = 3
            this.resSaveInfo = res.data
            this.commodityInfo.memberNo = res.data.miMember.memberNo
            this.commodityInfo.recommendNo = res.data.miMember.recommendNo
            this.commodityInfo.linkNo = res.data.poOrderVO.linkNo
            this.commodityInfo.name = res.data.miMember.name
            this.commodityInfo.paperType = res.data.miMember.paperType
            this.commodityInfo.paperNo = res.data.miMember.paperNo
            this.commodityInfo.bonusSendType = res.data.miMember.bonusSendType
            this.commodityInfo.mobile = res.data.miMember.mobile
            this.commodityInfo.accountBank = res.data.miMember.accountBank
            this.commodityInfo.accountName = res.data.miMember.accountName
            this.commodityInfo.accountCode = res.data.miMember.accountCode
            this.commodityInfo.officeTel = res.data.miMember.officeTel
            this.commodityInfo.storeAddr = res.data.miMember.storeAddr
            this.commodityInfo.storePost = res.data.miMember.storePost
            this.saveLoading = false
          }).catch(() => {
            this.saveLoading = false
            this.registerIF = 2
          })
        } else {
          this.saveLoading = false
        }
      })
    },
    btnSubmit() {
      if (this.CITime && this.companyCode === 'CI') {
        if (Number(this.totalFv) >= 400) {
          if (this.selectPromotion !== 1 && this.selectPromotion !== 2) {
            return this.$message.error(this.$t('poOrder.pleaseChoose') + this.$t('pdManifestItem.present')) // 请选择赠品
          }
        }
        if (this.qixueBuyQty > 0) {
          if (Number(this.qixue1 + this.qixue2) !== Number(this.qixueBuyQty)) {
            this.$message.error('Blood Circulative Massager' + this.$t('pdManifestItem.present') + this.$t('Please.Enter.Quantity')) // 血循环机赠品请输入正确的数量
            return false
          }
        }
      }
      if (this.buyQty <= 0) {
        return this.$message.error(this.$t('leastInputANumber'))
      }
      if (!this.saveInfo.payPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password'))
      } else {
        let lists = []
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].buyQty > 0) {
            lists.push(this.list[i])
          }
        }
        this.resSaveInfo.poOrderVO.goodsList = lists
        if (this.CITime && this.companyCode === 'CI') {
          if (Number(this.totalFv) >= 400 && this.qixueBuyQty > 0) {
            this.qixue1 = this.selectPromotion === 1 ? this.qixue1 + 1 : this.qixue1
            this.qixue2 = this.selectPromotion === 2 ? this.qixue2 + 1 : this.qixue2
            if (this.qixue1 > 0) {
              this.resSaveInfo.poOrderVO.goodsList.push(
                  {companycode: 'CI', goodscode: 'T006-04', isGive: 1, StandardPrice: 0, buyQty: this.qixue1}
              )
            }
            if (this.qixue2 > 0) {
              this.resSaveInfo.poOrderVO.goodsList.push(
                  {companycode: 'CI', goodscode: 'T004-00', isGive: 1, StandardPrice: 0, buyQty: this.qixue2}
              )
            }
          } else if (Number(this.totalFv) >= 400) {
            if (this.selectPromotion === 1) {
              this.resSaveInfo.poOrderVO.goodsList.push(
                  {companycode: 'CI', goodscode: 'T006-04', isGive: 1, StandardPrice: 0, buyQty: 1}
              )
            } else if (this.selectPromotion === 2) {
              this.resSaveInfo.poOrderVO.goodsList.push(
                  {companycode: 'CI', goodscode: 'T004-00', isGive: 1, StandardPrice: 0, buyQty: 1}
              )
            }
          }
        }
        this.resSaveInfo.poOrderVO.payPassword = this.saveInfo.payPassword
        this.saveLoading = true
        agentRegisterSecond({...this.resSaveInfo}).then(() => {
          this.$router.push({name: 'OrderQuery'})
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
          this.saveLoading = false
        }).catch(() => {
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
          this.saveLoading = false
        })
      }
    },
    // 取消按钮
    btnCancel() {
      this.$router.push({name:'OrderQuery'})
    },
    // 获取商品列表
    getGoodsList() {
      goodsListSGByMember().then(res=>{
        this.list = res.data
      })
    },
    // 获取公司的制度
    getBonusType() {
      getCompanyBonusType({'companyCode': this.companyCode}).then(res => {
        this.BonusType = res.data
      })
    }
  }
}
</script>

<style scoped lang="scss">
.turn-white {
  ::v-deep .el-input__inner{
    background-color: white;
    color: black;
  }
}
table {
  margin: 20px 0 20px 0;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }
  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }
  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}
.account_name_css:after {
  content: 'X';
  color: #ff4949;
}
.red-span {
  color: red;
}
.register_3_css {
  display: flex;
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
